// @flow

import React, { useEffect } from 'react'
import FlipMove from 'react-flip-move'

import Availability from './availability'
import BusinessHandleInput from './business-handle-input'

import clientData from 'utils/client-data'

import get from 'lodash/get'

import { handleAvailabilityAndSuggestions } from '../../../gql/mutation/handle-availability-and-suggestions'

import axios from 'axios'

const { CancelToken } = axios

function HandleInput(props) {
  const { selectedValue, inputValue, businessName } = props
  const { setValidBusinessHandle } = props.sellerProfileState

  const [error, setError] = React.useState(false)
  const [taken, setTaken] = React.useState(false)
  const [isValidHandle, setValidHandle] = React.useState(false)
  // const [value, setValue] = React.useState('')

  const [errorTextType, setErrorType] = React.useState('')

  const [suggestions, setSuggestions] = React.useState([])
  const [isLoading, setLoading] = React.useState(false)

  useEffect(() => {
    resetInput()
  }, [inputValue])

  const resetInput = () => {
    setError(false)
    setTaken(false)
    setValidHandle(false)
    setValidBusinessHandle(false)
  }

  const onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    setLoading(true)
    resetInput()
    const { updateBusinessHandle } = props
    updateBusinessHandle(e)
    const value = e.target.value
    const validKeyPress = validate(value)

    if (validKeyPress) {
      // updateBusinessHandle(e)
    } else {
      setError(true)
      setErrorType('invalid')
      setLoading(false)
    }
  }

  const validate = (value: string) => {
    const SLUG_VALIDATION_REGEX = /^[a-z0-9]*$/i

    if (SLUG_VALIDATION_REGEX.test(value)) {
      return true
    }
    return false
  }

  /*
   * TODO: Integrate with the paypalmeserv to call the seller
   *       profile handle check and suggestions.
   *
   *       Modify logic to fit object data coming back, currently
   *       using the same logic as personal profile
   *
   *       Currently using the old get slug for ppme
   */
  const checkSlugAvailability = async (handle, businessName, error) => {
    if (!handle) {
      return
    }

    const value = handle

    if (value.length === 0) {
      setLoading(false)
      setError(false)
      return {
        isErrorTextVisible: false,
        isHelperTextVisible: false,
      }
    }

    if (value.length < 3 && !error) {
      // NOTE: if you call hooks to set state on varibles that are used via onRef for debounce,
      //       an error will occur because the deferred promise gets nullifed
      //       return the data needed and read from results[some_name]
      setErrorType('tooShort')
      return {
        isErrorTextVisible: true,
      }
    } else if (value.length > 20 && !error) {
      setErrorType('tooLong')
      return {
        isErrorTextVisible: true,
      }
    }

    if (error) {
      return {
        isErrorTextVisible: true,
      }
    }

    const source = CancelToken.source()

    const variables = {
      handle: {
        preferred_id: value,
        business_name: businessName,
      },
    }

    const availabilityPayload = {
      query: handleAvailabilityAndSuggestions,
      variables,
    }
    const cancelPayload = {
      cancelToken: source.token,
    }
    const graphqlEndpoint = `${window.location.origin}${clientData.requestURI}/v1/graphql`

    let availabilityResponse
    axios.defaults.headers.post['x-csrf-token'] = get(clientData, 'csrf')

    availabilityResponse = await axios.post(
      graphqlEndpoint,
      availabilityPayload,
      cancelPayload,
    )

    setLoading(false)

    const isSlugAvailable = get(
      availabilityResponse,
      'data.data.handleAvailabilityAndSuggestions.isPreferredIdAvailable',
      false,
    )

    // const reason = get(
    //   availabilityResponse,
    //   'data.data.slugAvailabilityAndSuggestions.slugUnavailabilityReasonCode',
    //   '',
    // )

    const suggestedSlugs = get(
      availabilityResponse,
      'data.data.handleAvailabilityAndSuggestions.suggestedSlugs',
      [],
    )

    setSuggestions(suggestedSlugs)

    if (!isSlugAvailable) {
      setTaken(true)
      setErrorType('taken')
      setError(true)
      return
    } else {
      setError(false)
      setValidHandle(true)
      setValidBusinessHandle(true)
      return
    }
  }

  return (
    <>
      <BusinessHandleInput
        value={selectedValue || inputValue}
        isHandleAvailable={isValidHandle}
        isErrorTextVisible={error}
        errorTextType={errorTextType}
        isLoading={isLoading}
        updateBusinessHandle={onChange}
        checkSlugAvailability={checkSlugAvailability}
        businessName={businessName}
      />
      <FlipMove
        enterAnimation={'fade'}
        leaveAnimation={'fade'}
        duration={150}
        easing="ease-out"
        style={{ marginTop: 24 }}
      >
        {taken && (
          <Availability onSelect={onChange} suggestions={suggestions} />
        )}
      </FlipMove>
    </>
  )
}

export default HandleInput
